<template>
  <section>
    <base-accordion :title="titleLabel" :title-code="titleCode" :open="true" :large-height="true">

      <div
        class="inline-flex flex-wrap px-3 py-1 mx-3 mt-5 text-sm leading-snug rounded-sm bg-yellow text-darkblue info"
      >
        <div class="mr-4">
          <strong>{{ $t("common.maintananceIntervall") }}:</strong>
          {{ apiData.label }}
        </div>
        <div v-if="apiData.intervals[0]">
          <strong>{{ $t("common.intervals") }}:</strong>
          {{ apiData.intervals[0].intervals }}
        </div>
      </div>

      <div
        v-if="capacities.length"
        class="flex flex-wrap mx-3 mt-2 mb-3 text-sm leading-snug bg-gray-200 rounded-sm info"
      >
        <div
          v-for="capacity in capacities"
          :key="capacity.label"
          class="mx-1 mt-1"
        >
          {{ capacity.label }}
        </div>
      </div>

      <div class="flex flex-wrap">
        <base-product
          v-for="item in apiData.products"
          :itemData="item"
          :key="item.code"
          class="w-1/2 md:w-1/3 xl:w-1/4 2xl:w-1/5 3xl:w-1/6"
        />
      </div>
    </base-accordion>
  </section>
</template>

<script>
import BaseProduct from '@/components/BaseProduct.vue';
import BaseAccordion from '@/components/BaseAccordion.vue';

export default {
  props: {
    apiData: {
      required: true,
      type: Object
    },
    titleLabel: {
      type: String
    },
    titleCode: {
      type: String
    },
    capacities: {
      type: Array
    }
  },
  components: {
    BaseProduct,
    BaseAccordion
  }
};
</script>

<style lang="scss" scoped></style>
